import React, { useEffect, useRef, useState } from 'react';
import './Team.css';

const Team = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const isMobile = window.innerWidth < 768;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1, rootMargin: isMobile ? '0px' : '-150px' }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <section id="team" className={`team ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
      <div className="team-container">
        <h2 className={`section-title fade-in-up ${isVisible ? 'visible' : ''}`}>Fondateur</h2>
        <div className="team-content">
          <div className={`team-image-wrapper fade-in-left delay-100 ${isVisible ? 'visible' : ''}`}>
            <img src="/photo/equipe/photo-cv-entier.png" alt="Alix Caperan" className="team-image" />
            <div className="image-gradient"></div>
          </div>
          <div className={`team-info-wrapper fade-in-right delay-200 ${isVisible ? 'visible' : ''}`}>
            <div className="team-info">
              <h3 className="team-name">Alix Caperan</h3>
              <p className="team-role">Fondateur de MyAidgent</p>
              <p className="team-description">
                Passionné de tech depuis toujours, j'ai grandi en explorant comment les outils numériques peuvent transformer notre manière de travailler et résoudre des problèmes concrets. Aujourd'hui étudiant-entrepreneur à l'Université Paris-Dauphine, je conçois des solutions d'IA sur mesure pour les entreprises. Ce qui m'anime : relever de nouveaux défis techniques et concevoir des outils qui apportent une vraie utilité, en s'appuyant sur des architectures IA robustes et pensées pour répondre à des besoins concrets.
              </p>
            </div>
            <div className="contact-buttons">
              <a href="https://www.linkedin.com/in/alix-caperan/" target="_blank" rel="noopener noreferrer" className="contact-button">
                <img src="/photo/equipe/logo_linkedin.png" alt="LinkedIn" className="contact-icon" />
                <span>LinkedIn</span>
              </a>
              <a href="mailto:alix.caperan@outlook.fr" className="contact-button">
                <img src="/photo/equipe/logo_outlook.png" alt="Outlook" className="contact-icon" />
                <span>alix.caperan@outlook.fr</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
